<template>
  <div class="minbox">
<!--    <el-carousel :interval="5000" arrow="always" boolean>-->
<!--      <el-carousel-item v-for="(item, index) in swiperList" :key="index">-->
<!--        <div class="swiper-slide one" :style="item.style">-->
<!--          <div class="formbox">-->
<!--            <fieldset>-->
<!--              <legend>{{item.subtitle}}</legend>-->
<!--              <div>-->
<!--                <h2>{{item.name}}</h2>-->
<!--                <hr />-->
<!--                <span>{{item.note}}</span>-->
<!--                <p>-->
<!--                  <a :href="item.url" target="_blank">了解更多</a>-->
<!--                </p>-->
<!--              </div>-->
<!--            </fieldset>-->
<!--            <div class="mobile_fieldset">-->
<!--              {{item.subtitle}}-->
<!--              <h2>{{item.name}}</h2>-->
<!--              <p>-->
<!--                <a @click="swiperClick(item.url)">了解更多</a>-->
<!--              </p>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </el-carousel-item>-->
<!--    </el-carousel>-->
    <div class="contentbox">
      <div class="content">
        <h2>产品特点</h2>
        <ul class="trait">
          <li>
            <img src="../assets/indexa.png" alt />
            <h4>安全</h4>
            <p>专业技术·精益求精</p>
          </li>
          <li>
            <img src="../assets/indexw.png" alt />
             <h4>稳定</h4>
            <p>防高温·防震动·防冲击</p>
          </li>
          <li>
            <img src="../assets/indexg.png" alt />
             <h4>高速</h4>
            <p>高效RAID算法·快速重建技术</p>
          </li>
          <li>
            <img src="../assets/indexk.png" alt />
             <h4>可靠</h4>
            <p>企业级性能·企业级存储</p>
          </li>
        </ul>
      </div>
    </div>
<!--    <div class="contentbox usebox">-->
<!--      <div class="content">-->
<!--        <h2>应用领域</h2>-->
<!--        <ul class="use">-->
<!--         &lt;!&ndash; <li>-->
<!--            <img src="../assets/index.png" alt />-->
<!--            <p>加固计算机</p>-->
<!--          </li> &ndash;&gt;-->
<!--         &lt;!&ndash; <li>-->
<!--            <img src="../assets/index2.png" alt />-->
<!--            <p>车载设备</p>-->
<!--          </li> &ndash;&gt;-->
<!--        &lt;!&ndash;  <li>-->
<!--            <img src="../assets/index3.png" alt />-->
<!--            <p>航空仪器及其他地面设备</p>-->
<!--          </li> &ndash;&gt;-->
<!--          <li>-->
<!--            <img src="../assets/index4.png" alt />-->
<!--            <p>平板电脑</p>-->
<!--          </li>-->
<!--          <li>-->
<!--            <img src="../assets/index5.png" alt />-->
<!--            <p>电力系统</p>-->
<!--          </li>-->
<!--          <li>-->
<!--            <img src="../assets/index6.png" alt />-->
<!--            <p>航拍数据存储系统</p>-->
<!--          </li>-->
<!--          <li>-->
<!--            <img src="../assets/index12.png" alt />-->
<!--            <p>工控机存储系统</p>-->
<!--          </li>-->
<!--         &lt;!&ndash;' <li>-->
<!--            <img src="../assets/index8.png" alt />-->
<!--            <p>星地通信数据存储系统</p>-->
<!--          </li>' &ndash;&gt;-->
<!--        &lt;!&ndash;  <li>-->
<!--            <img src="../assets/index9.png" alt />-->
<!--            <p>高速数据采集系统</p>-->
<!--          </li> &ndash;&gt;-->
<!--          &lt;!&ndash; <li>-->
<!--            <img src="../assets/index10.png" alt />-->
<!--            <p>信号处理系统</p>-->
<!--          </li> &ndash;&gt;-->
<!--        </ul>-->
<!--      </div>-->
<!--    </div>-->
    <div class="aboutusbox">
      <div class="aboutus">
        <h2>关于我们</h2>
        <div class="imga">
          <img src="../assets/inedxbb.png" alt />
        </div>
        <div class="aucontent">
          <h3>武汉汇迪森信息技术有限公司</h3>
          <p>武汉汇迪森信息技术有限公司由一支多年从事固态存储研发、销售的精英团队创建。是一家拥有自主知识产权的固态存储和存储系统前沿技术的高科技公司。公司研发、生产和销售高可靠、高定制固态存储产品、存储系统并提供行业用定制化固态存储。</p>
          <button @click="goContactus">查看>></button>
        </div>

        <div></div>
      </div>
    </div>
  </div>
</template>

<script type="text/script">
import { getBanner } from "@/api/index.js";
// import Swiper from 'swiper'
import "element-ui/lib/theme-chalk/index.css";

export default {
  name: "minbox",
  data() {
    return {
      msg: "这是首页",
      swiperList: [],
    };
  },
  components: {},
  directives: {},
  mounted() {
    this.getSwiperList();
  },
  methods: {
    getSwiperList() {
      getBanner().then((res) => {
        if (res.code !== 200) return;
        let swiperList = res.data;
        swiperList.forEach((element) => {
          element.pic = process.env.BASE_API + "/web" + element.pic;
          element.style = {
            background: `url(${element.pic}) no-repeat`,
            backgroundSize: "100% 100%",
          };
        });
        this.swiperList = swiperList;
      });
    },
    goContactus() {
      this.$router.push({ path: "/cculture", query: { categoryId: 10 } });
    },
    swiperClick(url) {
      if (url) {
        window.location.href = url
      }
    }
  },
  destroyed() {},
};
</script>

<style scoped >
.mintop .wrapper {
  margin: auto;
  box-sizing: border-box;
  padding: 35px 40px 0;
  overflow: hidden;
}
@media screen and (max-width: 760px) {
  .minbox div.el-carousel {
    height: 250px;
  }
}
@media screen and (max-width: 1200px) {
  div.el-carousel {
    height: 350px;
  }
}
.el-carousel {
  width: 100%;
  height: 490px;
}

.el-carousel /deep/ .el-carousel__indicator.is-active button {
  background: #e50012;
}
.el-carousel /deep/ .el-carousel__container {
  width: 100%;
  height: 100%;
}

.el-carousel /deep/ .el-carousel__arrow--left {
  left: 0;
}
.el-carousel /deep/ .el-carousel__arrow--right {
  right: 0;
}
.el-carousel /deep/ .el-carousel__arrow {
  font-size: 40px !important;
  background-color: rgba(0, 0, 0, 0) !important;
}
.el-carousel__item {
  width: 100%;
  height: 100%;
}
.el-carousel__item .swiper-slide {
  width: 100%;
  height: 100%;
}

/* .el-carousel .el-carousel__item .one { */
/* background-size: 100% 100%; */
/* } */
.el-carousel .el-carousel__item .two {
  background: url(../assets/20200629-11440549.jpg) no-repeat;
  background-size: 100% 100%;
}
.el-carousel .el-carousel__item .three {
  background: url(../assets/20200620-13105554.jpg) no-repeat;
  background-size: 100% 100%;
}
@media screen and (max-width: 1200px) {
  .el-carousel .el-carousel__item .swiper-slide .formbox {
    padding: 45px;
  }
}
@media screen and (max-width: 1300px) {
  .el-carousel .el-carousel__item .swiper-slide .formbox {
    width: 100%;
  }
}
.el-carousel__item .swiper-slide .formbox {
  width: 1280px;
  height: 490px;
  margin: auto;
  padding: 65px 40px 0;
  box-sizing: border-box;
}
@media screen and (max-width: 1200px) {
  div.el-carousel .el-carousel__item .swiper-slide .formbox fieldset {
    /* border: 2px solid #333; */
    border: 2px solid #fff;
    padding: 0px 20px 0px;
    width: 380px;
    box-sizing: border-box;
    text-align: left;
    font-family: "LatoWebSemibold";
    font-size: 16px;
  }
}
@media screen and (max-width: 760px) {
  .el-carousel .el-carousel__item .swiper-slide .formbox {
    padding: 20px !important;
  }
}

.el-carousel .el-carousel__item .swiper-slide .formbox fieldset {
  border: 2px solid #fff;
  /* padding: 10px 30px 8px; */
  padding: 0px 20px 0px;
  /* width: 500px; */
  width: 480px;
  box-sizing: border-box;
  text-align: left;
  /* font-size: 18px; */
  font-family: "LatoWebSemibold";
  font-size: 16px;
  color: #fff;
}
@media screen and (max-width: 1200px) {
  div.el-carousel .el-carousel__item .swiper-slide .formbox fieldset legend {
    font-family: "LatoWebBold";
    font-weight: normal;
    padding: 5px 10px;
    font-size: 19px;
    text-align: left;
  }
}
.el-carousel .el-carousel__item .swiper-slide .formbox fieldset legend {
  font-family: "LatoWebBold";
  font-weight: normal;
  padding: 5px 10px;
  font-size: 19px;
  text-align: left;
  color: #fff;
}
@media screen and (max-width: 1200px) {
  div.el-carousel .el-carousel__item .swiper-slide .formbox fieldset h2 {
    font-size: 24px;
  }
}
.el-carousel .el-carousel__item .swiper-slide .formbox fieldset h2 {
  margin: 0;
  margin-bottom: 20px;
  font-size: 36px;
  font-family: "LatoWebBold";
  font-weight: normal;
}
.el-carousel .el-carousel__item .swiper-slide .formbox fieldset hr {
  margin-bottom: 20px;
}
.el-carousel .el-carousel__item .swiper-slide .formbox fieldset span {
  margin-bottom: 20px;
}
.el-carousel .el-carousel__item .swiper-slide .formbox fieldset p {
  margin: 20px 0;
}
.el-carousel .el-carousel__item .swiper-slide .formbox fieldset a {
  color: #15262e;
  text-decoration: underline;
  font-size: 14px;
  color: #fff;
}
@media screen and (max-width: 760px) {
  .el-carousel .el-carousel__item .swiper-slide .formbox fieldset {
    display: none;
  }
}
@media screen and (max-width: 760px) {
  .minbox
    .el-carousel
    .el-carousel__item
    .swiper-slide
    .formbox
    .mobile_fieldset {
    color: #fff;
    display: block;
    text-align: left;
  }
}
.el-carousel .el-carousel__item .swiper-slide .formbox .mobile_fieldset p {
  margin: 10px 0;
}
.el-carousel .el-carousel__item .swiper-slide .formbox .mobile_fieldset {
  display: none;
}
@media screen and (max-width: 760px) {
  .el-carousel .el-carousel__item .swiper-slide .formbox h2 {
    font-size: 26px;
  }
}
@media screen and (max-width: 760px) {
  .el-carousel .el-carousel__item .swiper-slide .formbox .mobile_fieldset {
    display: block;
    text-align: left;
  }
}
.el-carousel .el-carousel__item .swiper-slide .formbox .mobile_fieldset {
  display: none;
}
.el-carousel .el-carousel__item .swiper-slide .formbox .mobile_fieldset a {
  color: #fff;
  text-decoration: underline;
}
.contentbox {
  width: 100%;
  background-color: #fff;
  padding: 60px 0 160px;
}
@media screen and (max-width: 1300px) {
  div.contentbox {
    padding: 30px 0 80px;
  }
}
@media screen and (max-width: 760px) {
  div.contentbox {
    padding: 20px 0 40px;
  }
}
.contentbox .content {
  width: 1280px;
  margin: 0 auto;
}
@media screen and (max-width: 1300px) {
  .contentbox .content {
    width: 100%;
    margin: 0 auto;
  }
}
@media screen and (max-width: 760px) {
  div.contentbox .content h2 {
    font-size: 20px;
  }
}
.contentbox .content h2 {
  font-size: 37px;
  color: #000000;
  text-align: center;
  position: relative;
  font-weight: 800;
}
@media screen and (max-width: 760px) {
  div.contentbox .content h2::after {
    top: 26px;
    width: 70px;
    height: 1px;
    margin-left: -35px;
  }
}
.contentbox .content h2::after {
  content: "";
  width: 130px;
  height: 2px;
  background-color: #000;
  position: absolute;
  top: 60px;
  left: 50%;
  margin-left: -65px;
}
@media screen and (max-width: 760px) {
  div.contentbox .content .trait {
    padding-top: 30px;
  }
}
.contentbox .content .trait {
  width: 100%;
  overflow: hidden;
  padding-top: 90px;
}

@media screen and (max-width: 760px) {
  div.contentbox .content .trait li {
    height: auto;
    padding-bottom: 20px;
  }
}
.contentbox .content .trait li {
  float: left;
  width: 24%;
}
@media screen and (max-width: 760px) {
  div.contentbox .content .trait li h4 {
   font-size: 18px;
   padding: 5px 0;
  }
}
.contentbox .content .trait li h4{
  font-size: 22px;
  font-weight: 300;
  width:100%;
  overflow: hidden;
  line-height: 30px;
  height: 30px;
  text-align: center;
  color:#333;
  padding:10px 0;
}
@media screen and (max-width: 760px) {
  div.contentbox .content .trait li p {
   font-size: 16px;
  }
}
.contentbox .content .trait li p{
  width: 100%;
  font-size: 1rem;
  line-height: 30px;
  height: 30px;
  overflow: hidden;
  text-align: center;
}
.contentbox .content .trait li:nth-child(1) {
  border: 0;
}
.contentbox .content .trait li:nth-child(2) {
  margin-right: 1.5%;
}
.contentbox .content .trait li:nth-child(3) {
  margin-right: 1.5%;
}

@media screen and (max-width: 1200px) {
  div.contentbox .content .trait li img {
    width: 130px;
  }
}
@media screen and (max-width: 760px) {
  .minbox div.contentbox .content .trait li img {
    width: 70%;
  }
}
.contentbox .content .trait li img {
  width: 156px;
  height: auto;
  display: block;
  margin: 0 auto;
}
.usebox {
  background: url(../assets/indexcb.png) no-repeat;
  background-size: 100% 100%;
}
.usebox h2 {
  color: #fff !important;
}
.usebox h2::after {
  content: "";
  background-color: #fff !important;
}
.usebox ul {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 100px;
  overflow: hidden;
}
@media screen and (max-width: 1300px) {
  div.usebox ul {
    margin-top: 50px;
  }
}
@media screen and (max-width: 1300px) {
  div.usebox ul li {
    margin: 20px 2.5%;
  }
}
@media screen and (max-width: 1100px) {
  div.usebox ul li {
    margin: 20px 2.5%;
    width: 15%;
    /* height: 180px; */
  }
}
@media screen and (max-width: 760px) {
  div.usebox ul li {
    margin: 10px 2%;
    width: 46%;
    height: auto;
    padding-bottom: 20px;
  }
}
.usebox ul li {
  margin: 60px 2.5%;
  -moz-box-shadow: 0 0 5px #75767c;
  -webkit-box-shadow: 0 0 5px #75767c;
  box-shadow: 0 0 5px #75767c;
  padding-top: 17px;
  overflow: hidden;
  float: left;
  width: 15%;
  height: 170px;
  background-color: rgba(0, 0, 0, 0.4);
}
@media screen and (max-width: 760px) {
  .minbox .usebox ul li img {
    width: 60%;
    height: auto;
  }
}
@media screen and (max-width: 1000px) {
  div.usebox ul li img {
    width: 90px;
    height: 90px;
  }
}
.usebox ul li img {
  width: 115px;
  height: 115px;
  border-radius: 50%;
  display: block;
  margin: 0 auto;
}
.usebox ul li img:hover {
  background-color: #36a8ed;
}
@media screen and (max-width: 760px) {
  div.usebox ul li p {
    font-size: 14px;
    line-height: 24px;
  }
}
.usebox ul li p {
  margin-top: 17px;
  font-size: 16px;
  line-height: 24px;
  color: #fff;
  text-align: center;
}

@media screen and (max-width: 760px) {
  div.aboutusbox {
   background-image: none;
  }
}

.aboutusbox {
  width: 100%;
  background: url(../assets/power_con1_bg.jpg) center center no-repeat;
}
@media screen and (max-width: 760px) {
  .minbox div.aboutusbox .aboutus {
    height: auto;
width: 100%;
    padding: 20px 0;
  }
}
@media screen and (max-width: 1300px) {
  div.aboutusbox .aboutus {
    width: 90%;
    padding: 30px 0;
  }
}
.aboutusbox .aboutus {
  padding: 50px 0 100px;
  position: relative;
  width: 1114px;
  margin: 0 auto;
  /* background: url(../assets/bg2.png) no-repeat;
  background-size: 100% 100%; */
}
@media screen and (max-width: 760px) {
  .aboutusbox .aboutus .imga {
    width:95%;
    height: auto;
    margin:0 auto;
  }
}

.imga {
  width: 640px;
  height: 419px;
  margin-left: 147;
  margin-top: 50px;
}
.imga img {
  width: 100%;
  height: 100%;
}
@media screen and (max-width: 760px) {
  .aboutusbox .aboutus .aucontent  {
    position: static;
    width: 91%;
    padding-left:0!important;
    padding-right: 0!important;
    margin:0 auto;
    height: auto;
  }
}
@media screen and (max-width: 760px) {
  .aboutusbox .aboutus  .aucontent h3 {
    font-size: 20px;
    color: #333;
    line-height: 40px;
  }
}
.aucontent h3 {
  font-size: 29px;
  line-height: 61px;
  font-weight: 800;
  border-bottom: 1px solid #333;
  margin-bottom: 20px;
}
@media screen and (max-width: 760px) {
  .aboutusbox .aboutus .aucontent p {
    line-height: 24px;
    width: 100%;
    height: 96px;
  }
}

.aucontent {
  position: absolute;
  right: 0;
  top: 179px;
  padding: 22px 40px 0 20px;
  width: 475px;
  height: 341px;
  background: #fff;
}
@media screen and (max-width: 760px) {
  div .aboutus h2 {
    font-size: 20px;
    margin-bottom: 30px;
  }
}
.aboutus h2 {
  text-align: center;
  margin-bottom: 30px;
  font-size: 37px;
  color: #333;
  position: relative;
  font-weight: 800;
}
@media screen and (max-width: 760px) {
  div.aboutus h2::after {
 top: 26px;
    width: 70px;
    height: 1px;
    margin-left: -35px;
  }
}
.aboutus h2::after {
      content: "";
    width: 130px;
    height: 2px;
    background-color: #000;
    position: absolute;
    top: 60px;
    left: 50%;
    margin-left: -65px;
}
@media screen and (max-width: 760px) {
  .aboutusbox .aboutus .aucontent p {
    font-size: 14px;
    color: #333;
    line-height: 20px;
    width: 100%;
    height: 80px;
  }
}
@media screen and (max-width: 1300px) {
  .aboutus .aucontent p {
    color: #333;
    line-height: 24px;
    width: 90%;
    height: 96px;
  }
}
.aucontent p {
  font-size: 14px;
  line-height: 30px;
  color: #666666;
  color: #333;
  width: 100%;
  height: 120px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
}
.aucontent button {
  width: 148px;
  height: 42px;
  border: 1px solid #333;
  font-size: 14px;
  color: #333;
  background-color: rgba(0, 0, 0, 0);
  margin-top: 40px;
}
.aucontent button:hover {
  /* background-color: red; */
  background-color: #0076e7;
  color: #fff;
  border-color: #fff;
}
@media screen and (max-width: 760px) {
  .aboutus .aucontent button {
    width: 100%;
    height: 30px;
    border:0;
    font-size: 18px;
    color: #fff;
    background-color: rgba(0, 0, 0, 0);
    margin-top: 30px;
    background-color: #146cbd;
  }
}
</style>





// WEBPACK FOOTER //
// src/pages/index.vue